












































































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {ProjectStaffAppUserViewModel, ProjectStaffEditModel} from '@/services/api/nswag/stapiclient_generated';
import {projectStaffApi} from '@/services/st-api';
import {clone} from '@/utlitities/helper';
import {UserStore} from '@/store/user-module';
import StRatePicker from "@/components/basic/StRatePicker.vue";

@Component({
  components: { StRatePicker },
})
export default class ProjectStaffEdit extends Vue {
  @Prop() projectId!: number;
  @Prop() value!: ProjectStaffEditModel[];
  @Prop() appUsers!: ProjectStaffAppUserViewModel[];
  @Prop() disabled!: boolean;
  assignedAppUserId: number = 0;

  get assignableStaff() {
    return this.appUsers
        .filter(x => !this.explicitAssignedStaff.some(y => y.appUserId == x.appUserId) && !this.allProjectsAppUsers.some(y => y.appUserId == x.appUserId));
  }

  get allProjectsAppUsers() {
    return this.appUsers
        .filter(x => x.canEditTimeEntriesForAllProjects);
  }

  get explicitAssignedStaff(){
   return this.projectStaff.filter(x=>!this.allProjectsAppUsers.map(y=>y.appUserId).some(y=>y == x.appUserId));
  }

  get projectStaff() {
    return this.value;
  }

  set projectStaff(data: ProjectStaffEditModel[]) {
    this.$emit('input', data);
  }

  getAllProjectUserCanViewAll(appUser: ProjectStaffAppUserViewModel){
    if(appUser.canViewTimeEntriesForEmployees){
      return true;
    }

    return this.projectStaff.find(x=>x.appUserId == appUser.appUserId)?.canViewAllProjectTimeEntries;
  }

  toggleAllProjectUserCanViewAll(appUser: ProjectStaffAppUserViewModel){
    const idx = this.projectStaff.findIndex(x=>x.appUserId == appUser.appUserId);

    if(idx == -1){
      let newItem: ProjectStaffEditModel = ProjectStaffEditModel.fromJS({
        projectId: this.projectId,
        appUserId: appUser.appUserId,
        canViewAllProjectTimeEntries: true
      });

      this.projectStaff.push(newItem);
    }else{
      this.projectStaff.splice(idx,1);
    }
  }

  getAppUserName(appUserId: number) {
    return this.appUsers.find(x => x.appUserId == appUserId)?.appUserName;
  }

  getCanViewTimeEntriesEmployeesGlobal(appUserId: number) {
    return this.appUsers.find(x => x.appUserId == appUserId)?.canViewTimeEntriesForEmployees;
  }

  unassignEmployee(index: number) {
    this.projectStaff.splice(index, 1);
  }

  assignEmployee() {
    let newItem: ProjectStaffEditModel = ProjectStaffEditModel.fromJS({
      projectId: this.projectId,
      appUserId: this.assignedAppUserId,
      canViewAllProjectTimeEntries: false
    });

    this.projectStaff.push(newItem);

    this.assignedAppUserId = 0;
  }
}
